import './_style.scss'
import EventEmitterManager from '../../core/event/EventEmitterManager'
import VisibilitySwitcherElement from '../../core/element/VisibilitySwitcherElement'
import Listener from '../../core/watcher/Listener'

Listener.onLoad(() => {
   const selector = '.offer-sticky'
   if (document.querySelector(selector)) {
      const offerStickySwitcher = new VisibilitySwitcherElement(document.querySelector(selector))
      EventEmitterManager.subscribeScrolledBelowOfferSlider(offerStickySwitcher.show)
      EventEmitterManager.subscribeScrolledAboveOfferSlider(offerStickySwitcher.hide)
   } else {
      console.log('selector "' + selector + '" is NULL')
   }
})